import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { emptyObject } from 'ui-components/default-props/empty';
import Global from '../../store/global-selectors';
import FormattedCurrencyContainer from '../formatted-currency/container';

export const FormattedBalance = ({ balance = emptyObject }) => {
  const sellerDefaultCurrencyCode = useSelector(Global.selectSellerDefaultCurrency);
  return balance?.value && balance?.code ? (
    <FormattedCurrencyContainer currencyCode={balance.code} value={balance.value} />
  ) : (
    <FormattedCurrencyContainer currencyCode={sellerDefaultCurrencyCode} value={0} />
  );
};

FormattedBalance.propTypes = {
  balance: PropTypes.shape({
    value: PropTypes.number,
    code: PropTypes.string,
  }),
};
